export default {
  //+-------------------------------------------------
  // Languages
  // -----
  // Created on Fri Feb 07 2025
  //+-------------------------------------------------
  LANGUAGES: [
    { key: 'en', label: 'English' },
    { key: 'es', label: 'Spanish' },
    { key: 'de', label: 'German' },

    { key: 'ar', label: 'Arabic' },
    { key: 'bg', label: 'Bulgarian' },
    { key: 'zh_CN', label: 'Chinese - Simplified' },
    { key: 'zh_TW', label: 'Chinese - Traditional' },
    { key: 'cs', label: 'Czech' },
    { key: 'da', label: 'Danish' },
    { key: 'nl', label: 'Dutch' },
    { key: 'fa', label: 'Farsi' },
    { key: 'fi', label: 'Finnish' },
    { key: 'fr', label: 'French' },
    { key: 'el', label: 'Greek' },
    { key: 'he', label: 'Hebrew' },
    { key: 'hi', label: 'Hindi' },
    { key: 'hu', label: 'Hungarian' },
    { key: 'id', label: 'Indonesian' },
    { key: 'it', label: 'Italian' },
    { key: 'ja', label: 'Japanese' },
    { key: 'ko', label: 'Korean' },
    { key: 'ms', label: 'Malay' },
    { key: 'no', label: 'Norwegian' },
    { key: 'pl', label: 'Polish' },
    { key: 'pt_BR', label: 'Portuguese - Brazil' },
    { key: 'pt_PT', label: 'Portuguese - Portugal' },
    { key: 'ro', label: 'Romanian' },
    { key: 'ru', label: 'Russian' },
    { key: 'sv', label: 'Swedish' },
    { key: 'th', label: 'Thai' },
    { key: 'tr', label: 'Turkish' },
    { key: 'uk', label: 'Ukrainian' },
    { key: 'vi', label: 'Vietnamese' },
  ],
}
